import { Container, Section } from '@repo/ui'
import { Button } from '@repo/ui/components/ui/button'
import { Card, CardContent } from '@repo/ui/components/ui/card'
import { Link } from '@tanstack/react-router'

interface PostCTAProps {
  title?: string
  description?: string
  buttonText?: string
  buttonLink?: string
}

export function PostCTA({
  title = 'Ready to Build Your SaaS?',
  description = 'Get started with our complete SaaS starter kit. Everything you need to launch your next project in days, not months.',
  buttonText = 'View Pricing',
  buttonLink = '/',
}: PostCTAProps) {
  return (
    <Section variant="default">
      <Container size="prose">
        <Card className="bg-gradient-to-br from-primary/5 to-accent/5">
          <CardContent className="text-center">
            <h2 className="mb-3 text-2xl font-semibold">{title}</h2>
            <p className="mx-auto mb-6 max-w-2xl text-muted-foreground">{description}</p>
            <Button asChild size="lg">
              <Link to={buttonLink}>{buttonText}</Link>
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Section>
  )
}
